// Using conditional type here
// ( https://artsy.github.io/blog/2018/11/21/conditional-types-in-typescript/ )
// so it returns `undefined` for `param: undefined`
export function parseStringParam(param) {
    if (typeof param === 'undefined') {
        return param;
    }
    return (Array.isArray(param) ? param[0] : param);
}
export function toSearchQueryParams(query) {
    var str = [];
    Object.keys(query).forEach(function (param) {
        if (query.hasOwnProperty(param)) {
            var value = parseStringParam(query[param]);
            str.push("".concat(encodeURIComponent(param), "=").concat(value ? encodeURIComponent(value) : ''));
        }
    });
    return str.length > 0 ? "?".concat(str.join('&')) : '';
}
